<template>
  <div v-if="!allLoaded" :class="wrapperClass">
    <button :class="buttonClass" @click="loadMore">
      {{loadMoreText}}
    </button>
  </div>
</template>

<script>
import VariantMixin from '@mixins/variant-mixin'

export default {
  name: 'load-more-pagination',
  mixins: [
    VariantMixin(
      // Component name
      'paginations',
      // Automatic generated computed properties
      [ 'buttonClass',
        'wrapperClass', ]
    )
  ],
  props: {
    value: {
      type: Object,
      required: true
    },
    defaultLimit: {
      type: Number,
      required: true
    },
    loadMoreText: {
      type: String,
      default: 'Load more'
    },
    allLoaded: Boolean
  },
  data: () => ({
    localValue: null
  }),
  computed: {
    scope() {
      return {
        loadMore: this.loadMore
      }
    }
  },
  watch: {
    /**
     * Keeping track of local value to emit input event
     */
    localValue(val) {
      const { localValString, valString } = this.getValuesStrings(val)
      if (localValString !== valString) {
        this.$emit('input', val)
      }
    },
    /**
     * Keeping track of external value to update internal on change
     */
    value(val) {
      const { localValString, valString } = this.getValuesStrings(val)
      if (localValString !== valString) {
        this.updateLocalValue()
      }
    }
  },
  created() {
    this.updateLocalValue()
  },
  methods: {
    loadMore() {
      this.localValue.$limit = this.localValue.$limit + this.defaultLimit
    },
    getValuesStrings(val) {
      const localValString = JSON.stringify(val)
      const valString = JSON.stringify(this.value)
      return { localValString, valString }
    },
    updateLocalValue() {
      this.localValue = this.value
    }
  }
}
</script>